import { useContext, useState } from "react"
import { Link } from "react-router-dom"
import * as React from "react"
import { Context } from "../../store/store"
import Slider from "react-slick"
import "../../slickslider.css"
import MafoQuestionTwo from "./Mafos/MafoQuestionTwo"
import MafoQuestionThree from "./Mafos/MafoQuestionThree"
import MafoQuestionFour from "./Mafos/MafoQuestionFour"
import MafoQuestionFive from "./Mafos/MafoQuestionFive"
import MafoQuestionSix from "./Mafos/MAfoQuestionSix"
import MafoQuestionSeven from "./Mafos/MafoQuestionSeven"
import MafoQuestionOne from "./Mafos/MafoQuestionOne"
import MafoQuestionEight from "./Mafos/MafoQuestionEight"
import MafoQuestionNine from "./Mafos/MafoQuestionNine"

interface MafoProps {
	formElementChanged: Function
	validation: Object
}
const Mafo: React.FC<MafoProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	const [slider, setSlider] = useState<any>(null)
	const [isFirstSlide, setIsFirstSlide] = useState<Boolean>(false)
	const [isLastSlide, setIsLastSlide] = useState<Boolean>(true)

	const next = () => {
		slider?.slickNext()
	}
	const previous = () => {
		slider?.slickPrev()
	}
	var settings = {
		dots: true,
		infinite: false,
		speed: 100,
		slidesToShow: 1,
		arrows: false,
		slidesToScroll: 1,
		swipeToSlide: true,
		initialSlide: 0,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					arrows: false,
					slidesToScroll: 3,
					infinite: false,
					dots: true,
					adaptiveHeight: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 2,
					dots: true,
					arrows: false,
					adaptiveHeight: true,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					dots: true,
					arrows: false,
					speed: 300,
					infinite: false,
					slidesToScroll: 1,
					adaptiveHeight: true,
				},
			},
		],
		beforeChange: current => {
			switch (current) {
				case 0:
					setIsFirstSlide(false)
					break
				case 1:
					setIsFirstSlide(true)
					break
				case 5:
					setIsLastSlide(false)
					break
				default:
					setIsFirstSlide(true)
					setIsLastSlide(true)
			}
		},
	}
	return (
		<div className=" mx-auto mb-12 mt-12 md:max-w-[900px] lg:mt-24">
			<h2 className="mt-6 mb-4 text-center font-Alpro text-[36px] uppercase text-white lg:text-[58px]">Bevor du absendest</h2>
			<p className="mx-auto mb-6 text-center font-Hurme text-[18px] leading-[22px] text-white lg:max-w-[75%] lg:text-[22px] lg:leading-[37px]">
				Zum Schluss haben wir noch ein paar Fragen. Die ersten 4 Fragen sind verpflichtend. Deine Antworten werden anonym behandelt.
			</p>
			<div className="mx-auto max-w-[90%] overflow-hidden rounded-xl bg-white py-6 md:py-12">
				<Slider ref={(c: any) => setSlider(c)} {...settings} className="h-auto">
					<div className="py-1 px-6">
						<MafoQuestionOne {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionTwo {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionThree {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionFour {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionFive {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionSix {...{ validation, formElementChanged }} />
					</div>
					<div className="py-1 px-6">
						<MafoQuestionSeven {...{ validation, formElementChanged }} />
					</div>
				</Slider>
				<div className="mx-auto mt-12 grid max-w-[100%] cursor-pointer grid-cols-1 items-center px-6 text-[22px] lg:text-[32px]">
					<div className="justify-self-center ">
						{isLastSlide && (
							<a
								className="mb-6 block w-[100%] bg-blue p-4 font-Alpro text-[24px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block lg:py-2 lg:px-6"
								onClick={() => {
									next()
								}}
							>
								Weiter
							</a>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default Mafo
